import { cn } from '@repo/utils';

interface SkeletonProps {
  className?: string;
  rows?: number;
}

function SkeletonBlock({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'bg-surface-2 rounded-[6px] relative overflow-hidden',
        'after:absolute after:inset-0 after:bg-gradient-to-r after:from-transparent after:via-surface-3 after:to-transparent after:translate-x-[-100%]',
        '[&::after]:[animation:skeleton-shimmer_1.5s_ease-in-out_infinite]',
        className,
      )}
    />
  );
}

export function Skeleton({ className, rows = 1 }: SkeletonProps) {
  if (rows === 1) return <SkeletonBlock className={cn('h-4 w-full', className)} />;
  return (
    <div className="flex flex-col gap-2">
      {Array.from({ length: rows }, (_, i) => (
        <SkeletonBlock
          key={i}
          className={cn('h-4', i === rows - 1 ? 'w-3/4' : 'w-full')}
        />
      ))}
    </div>
  );
}

export function TableSkeleton({ columns = 4, rows = 8 }: { columns?: number; rows?: number }) {
  return (
    <div className="w-full" role="status" aria-label="Loading">
      <div className="flex gap-3 px-3 py-2 border-b border-border bg-surface-2">
        {Array.from({ length: columns }, (_, i) => (
          <SkeletonBlock key={i} className="h-3 flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex gap-3 px-3 py-3 border-b border-border">
          {Array.from({ length: columns }, (_, j) => (
            <SkeletonBlock key={j} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}
